import { TopbarComponent } from "./topbarComponent";

export const ProviderTopbar = TopbarComponent;
